const NGINX_DOMAIN = process.env.NGINX_DOMAIN || 'glassesusa.dev';

// For non development we must use internal k8 network
export const MAGENTO_HOST = process.env.APP_ENV === 'development' ? NGINX_DOMAIN : 'localhost';

export const SITE_URL = __NODEJS__ ? `https://${MAGENTO_HOST}/backend/` : '/backend/';
export const BLOG_API_URL = __NODEJS__ ? `https://${MAGENTO_HOST}/blog-api/` : '/blog-api/';

// For production we must use internal k8 network
const MS_HOST =
    process.env.APP_ENV === 'production'
        ? 'api.glassesusa.com/'
        : `${NGINX_DOMAIN}${process.env.API_URL}`;

export const API_URL = __NODEJS__
    ? `https://${MS_HOST}`
    : process.env.API_URL || 'https://api.glassesusa.com/';

export const MS_MEDIA_URL_PREFIX = process.env.MS_MEDIA_URL || '/ms/media';

export enum HTTP_REQUEST_HEADER {
    CONTENT_TYPE = 'Content-Type',
    STORE = 'store',
    AUTHORIZATION = 'Authorization',
    DY_API_KEY = 'dy-api-key',
    /**
     * possible values:
     * 1 - enable cache (if request contains Set-Cookie header cache won't be enabled)
     * 0 - disable cache
     */
    ENABLE_CACHE = 'x-cache-query',
    ACCEPT_ENCODING = 'Accept-Encoding',
}

export enum HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE {
    MULTIPART_FORM_DATA = 'multipart/form-data',
    APPLICATION_JSON = 'application/json',
}

export const HTTP_REQUEST_HEADER_ACCEPT_ENCODING_VALUE = 'gzip';

export const KUBERNETES_USER_AGENT = 'kube-probe/';
